import React, { useEffect } from 'react';
import {
  animate,
  motion,
  useMotionTemplate,
  useMotionValue,
  useTransform,
} from 'framer-motion';

type AnimatedNumberProps = {
  target: number;
  suffix?: string;
  inView: boolean;
};

const AnimatedNumber: React.FC<AnimatedNumberProps> = ({ target, suffix = '', inView }) => {
  const motionValue = useMotionValue(0);
  const rounded = useTransform(motionValue, (v) => Math.floor(v));
  const display = useMotionTemplate`${rounded}${suffix}`;

  useEffect(() => {
    if (inView) {
      const controls = animate(motionValue, target, {
        duration: 4,
        ease: 'easeOut',
      });
      return () => controls.stop();
    }
    return () => {};
  }, [inView, motionValue, target]);

  return (
    <motion.span style={{ fontSize: '3rem', fontWeight: 700 }}>
      {display}
    </motion.span>
  );
};

export default AnimatedNumber;
